export const AI_INSPECTIONS_PATH = '/Modules/data-entry/inspection-ai'

// Estado global del drawer de procesos CheckR, para poder abrirlo desde el menu lateral
// (Navbar) y no solo desde el boton de la pantalla de AI Inspections.
export function useCheckrProcessDrawer() {
  const open = useState<boolean>('checkr-process-drawer-open', () => false)
  return { open }
}
